import { render } from "./TabTable.vue?vue&type=template&id=0e5cff28&scoped=true"
import script from "./TabTable.vue?vue&type=script&lang=js"
export * from "./TabTable.vue?vue&type=script&lang=js"

import "./TabTable.vue?vue&type=style&index=0&id=0e5cff28&lang=scss&scoped=true"

import exportComponent from "/home/vitsuji/Projects/iGEM-Wiki/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5cff28"]])

export default __exports__